import { Box, LinearProgress as LinearProgressMaterial, Typography } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';

interface IProps {
    value?: number;
    showNumber?: boolean;
    determinate?: boolean;
}
export const LinearProgress: FC<IProps> = ({ value = 100, showNumber, determinate }) => {
    return (
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
            <Box sx={{ width: '100%' }}>
                <LinearProgressMaterial variant={determinate ? 'determinate' : undefined} value={value} />
            </Box>
            {showNumber && (
                <Typography variant="subtitle1" sx={{ color: Colors.cloudBurstBlue }}>
                    {value}%
                </Typography>
            )}
        </Box>
    );
};
